import { Theme } from "@mui/material";
import { ChartTooltip } from "@components/Tooltip/ChartTooltip";

interface Props {
  year: string;
  amount: string;
  color: string;
  theme: Theme;
}

export const DividendsTooltip = ({ year, amount, color, theme }: Props) => (
  <ChartTooltip theme={theme}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontSize: theme.typography.caption.fontSize,
        lineHeight: theme.typography.caption.lineHeight,
        color: theme.palette.text.onTooltipPrimary,
      }}
    >
      <div
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: color,
        }}
      />
      <div style={{ fontWeight: 500 }}>{year}</div>
      <div style={{ fontWeight: 600 }}>{amount}</div>
    </div>
  </ChartTooltip>
);
